import { FormProvider } from "react-hook-form";
import React, { createContext, useContext, useMemo } from "react";
import { EDBFormContextType } from "../types/edb.types";
import { useEDBFormLogic } from "../hooks/useEDBFormLogic";

export const EDBFormContext = createContext<EDBFormContextType | undefined>(
  undefined
);

export const useEDBFormContext = () => {
  const context = useContext(EDBFormContext);
  if (context === undefined) {
    throw new Error("useEDBFormContext must be used within an EDBFormProvider");
  }
  return context;
};

interface EDBFormProviderProps {
  children: React.ReactNode;
  idEdb: string | null;
  currentEdb: any;
}

export const EDBFormProvider: React.FC<EDBFormProviderProps> = ({
  children,
  idEdb,
  currentEdb,
}) => {
  const formLogic = useEDBFormLogic({ idEdb, currentEdb });

  const value = useMemo(
    () => ({
      idEdb,
      currentEdb,
      ...formLogic,
    }),
    [idEdb, currentEdb, formLogic]
  );

  return (
    <EDBFormContext.Provider value={value}>
      <FormProvider {...formLogic}>{children}</FormProvider>
    </EDBFormContext.Provider>
  );
};
